import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g>
      <polygon fill="#F04E98" points="0 10.001 24 10.001 24 0 0 0"/>
      <path className="euiIcon__fillNegative" d="M32,20 L20,20 C14.478,20 10,15.522 10,10 L32,10 L32,20 Z"/>
      <polygon fill="#0080D5" points="20 32 32 32 32 23 20 23"/>
    </g>
  </svg>
);
